import React from "react";
import GooglePayButton from "@google-pay/button-react";
import { useTranslation } from "react-i18next";
import useFlash from "go-alert/AlertMessage";
import handleError from "go-app/services/errors";
import { ApiError, MoneyApi } from "go-core/api/types";
import FormatMoney from "go-core/components/Formatters/FormatMoney";
import { OrderTransactionApi } from "../../../../../../../../../services/Api/Public/types";
import { paymentEnvironment } from "../../../../../../../../../utils/envutil";
import { API_VERSION, API_VERSION_MINOR, allowedPaymentMethods, getTransactionInfo } from "../../../../../utils";
import OrderPaymentInfo from "../../OrderPaymentInfo";

interface Props {
	totalPrice: MoneyApi;
	handleOnLoadPayment: (
		token: string,
		callback?: (data: OrderTransactionApi) => Promise<void> | void
	) => (e?: React.BaseSyntheticEvent) => Promise<void>;
	setIsProcessing: React.Dispatch<React.SetStateAction<boolean>>;
	customFormErrors: ApiError[];
	validatePaymentDataOnClick: () => boolean;
	checkTransaction: (data: OrderTransactionApi) => Promise<void>;
	merchantId: string;
}

const PayViaGooglePayButton = ({
	totalPrice,
	handleOnLoadPayment,
	setIsProcessing,
	validatePaymentDataOnClick,
	checkTransaction,
	merchantId,
}: Props) => {
	const { t } = useTranslation();
	const { addFlash } = useFlash();

	const checkValidation = (event: Event) => {
		const valid = validatePaymentDataOnClick();
		if (!valid) {
			event.preventDefault();
		}
		return valid;
	};

	return (
		<div className="button-payment-container d-flex flex-column google-pay-button-container">
			<div className="d-flex align-items-center justify-content-between">
				<p className="mb-0 text-muted">{`${t("modules.e_order.field.total_price.title")}:`}</p>
				<p className="mb-0">{FormatMoney(totalPrice)}</p>
			</div>
			<GooglePayButton
				className="w-100"
				environment={paymentEnvironment()}
				buttonType="buy"
				buttonSizeMode="fill"
				paymentRequest={{
					apiVersion: API_VERSION,
					apiVersionMinor: API_VERSION_MINOR,
					allowedPaymentMethods,
					merchantInfo: {
						merchantId,
					},
					transactionInfo: getTransactionInfo(totalPrice, t),
				}}
				onLoadPaymentData={(paymentData) =>
					handleOnLoadPayment(btoa(paymentData.paymentMethodData.tokenizationData.token), checkTransaction)()
				}
				onClick={checkValidation}
				onError={(err) => {
					setIsProcessing(false);
					handleError.alert(err, addFlash);
				}}
			/>
			<OrderPaymentInfo centerText />
		</div>
	);
};

export default PayViaGooglePayButton;
